import React, { useEffect, useState } from "react";
import CareerHeader from "./CareerHeader";
import CareerCard from "./CareerCard";
import { clearFolderObj } from "../../features/folder/folderSlice";
import { useDispatch } from "react-redux";
import { clearAuthObj } from "../../features/auth/authSlice";
import { clearDropObj } from "../../features/dropdown/dropdownSlice";
import { clearSaveObj } from "../../features/save/saveSlice";
import { clearStaffObj } from "../../features/staff-setting/staffSettingSlice";

function CareerList() {
  const dispatch = useDispatch();
  const [searchInput, setsearchInput] = useState(null);
  useEffect(() => {
    dispatch(clearFolderObj());
    // dispatch(clearAuthObj());
    dispatch(clearDropObj());
    dispatch(clearSaveObj());
    dispatch(clearStaffObj());
  }, []);

  return (
    <div className="flex flex-col h-[100vh] overflow-y-scroll  w-full bg-[#F9F9F9]">
      <CareerHeader searchInput={searchInput} setsearchInput={setsearchInput} />
      <CareerCard />
    </div>
  );
}

export default CareerList;
